import { render, staticRenderFns } from "./RatingAction.vue?vue&type=template&id=63ed4aa0&scoped=true"
import script from "./RatingAction.vue?vue&type=script&lang=js"
export * from "./RatingAction.vue?vue&type=script&lang=js"
import style0 from "./RatingAction.vue?vue&type=style&index=0&id=63ed4aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed4aa0",
  null
  
)

export default component.exports